import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import ListIcon from "@redotech/redo-icons/list.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.pickSessionIdValue;

export const PickSessionIdFilter: ArrayStringTableFilter<string> = {
  type: entry.type,
  itemLabel: "Session ID",
  operators: entry.operators,
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: ListIcon,
  displayName: entry.displayName,
  dbSearch: true,
};
